import Component from '../core/Component'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'
import { triggerEvent, toggleClass } from '../utils/dom'
import CourseState from '../meta/CourseState'

const STATES = {
    RATED: 'is-rated',
    SENT: 'is-sent'
}

export default class CourseRatingForm extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            scale: null,
            button: null,
            textarea: null,
            placeholder: null,
            groupId: null
        }

        this.height = 0
        this.courseCompleted = false

        this.handleResize = throttle(::this.handleResize, 200)
    }

    prepare() {
        this.ref.textarea.addEventListener('input', this.handleInput)
        this.ref.scale.addEventListener('change', this.handleChange)
        this.element.addEventListener('submit', this.handleSubmit)

        EventBus.on('set:completed', this.handleSetCompleted)
        EventBus.on('course:completed', this.handleCourseCompleted)

        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)

        window.addEventListener('resize', this.handleResize)
        this.resize()
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
        EventBus.off('set:completed', this.handleSetCompleted)
    }

    handleCourseCompleted = () => {
        this.courseCompleted = true
        this.reset()
    }

    handleSetCompleted = ({ id }) => {
        if (this.courseCompleted) {
            return
        }

        this.ref.groupId.value = id
    }

    handleResize() {
        this.resize()
    }

    handleChange = () => {
        this.element.classList.add(STATES.RATED)
        this.submit()
    }

    handleInput = event => {
        this.resize()
    }

    handleStateChange = state => {
        this.render(state)
    }

    handleSubmit = event => {
        event.preventDefault()
        this.submit()
    }

    resize() {
        this.ref.placeholder.textContent = this.ref.textarea.value

        if (this.ref.placeholder.offsetHeight !== this.ref.textarea.offsetHeight) {
            this.ref.textarea.style.height = `${this.ref.placeholder.offsetHeight}px`
        }
    }

    reset() {
        this.element.reset()
        this.ref.groupId.value = ''
        this.element.classList.remove(STATES.RATED)
    }

    submit() {
        const data = new FormData(this.element)
        const feedback = this.ref.textarea.value.trim() !== ''

        $.nette.ajax({
            url: this.element.action,
            type: this.element.method || 'POST',
            data: $(this.element).serialize(),
            success: () => {
                if (feedback) {
                    if (this.ref.groupId.value) {
                        CourseState.state.rating.sent = true
                    } else {
                        CourseState.state.rating.sentAll = true
                    }
                    CourseState.commit()
                }
            }
        })
    }

    render(state) {
        const { rating } = state
        const lessons = Object.values(state.lessons)
        const completed = lessons.filter(lesson => lesson.completed).length
        const isCourseComplete = completed === lessons.length

        toggleClass(this.element, STATES.SENT, (rating.sentAll && isCourseComplete) || (rating.sent && !isCourseComplete))
    }
}